import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { LieferungStatusLabel } from 'utils/labels';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';

interface LieferungStatusProps {
    disabled?: boolean;
    value: string;
    addAll?: boolean;
    renderLabel?: 'label' | 'placeholder';
    onChange: (newValue: string) => void;
}

const allOption = { value: '__all__', label: 'Alle' };

export const LieferungStatus: React.FC<LieferungStatusProps> = ({
    value,
    disabled = false,
    renderLabel = 'label',
    onChange,
    addAll = false,
}) => {
    const options = React.useMemo(() => {
        const list: SelectOption[] = [];
        if (addAll) {
            list.push(allOption);
        }

        Object.keys(LieferungStatusLabel).forEach((key) => {
            list.push({
                value: key,
                label: LieferungStatusLabel[key],
            });
        });

        return list;
    }, [addAll]);

    const selectedOption = React.useMemo(() => {
        if (value === '__all__') {
            return allOption;
        }

        if (value) {
            return {
                value,
                label: LieferungStatusLabel[value] || value,
            };
        }

        return {
            value: '',
            label: '',
        };
    }, [value]);

    return (
        <>
            {renderLabel === 'label' && <Label>Status</Label>}
            <Select
                name="status"
                isDisabled={disabled}
                value={selectedOption}
                options={options}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    onChange(option?.value || '__all__');
                }}
                placeholder={renderLabel === 'placeholder' ? 'Status' : ''}
            />
        </>
    );
};
